import React from "react";
import { Link } from "react-router-dom";

const GenresCard = ({ index, id, title, image }) => {
  return (
    <Link to={`/animes`} state={{ mal_id: `${id}` }}>
      <div
        className={`group flex w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight  bg-cover bg-no-repeat bg-center ${
          index === 0 ? " mr-[10px] ml-[2px]" : "mx-[10px]"
        } md:m-sm bg-fill rounded-md  ring-2  ring-white`}
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className="bg-black/50 h-full w-full flex justify-center items-center">
          <h1 className="font-display text-xm">{title}</h1>
        </div>
      </div>
    </Link>
  );
};

export default GenresCard;
